
import { Component } from '@angular/core';
import { WidgetConfigurationItemObj } from '@wizeoo/akm-message-lib';
import { EM_ACTION } from '@wizeoo/akm-compute-lib';

import { WIDGET_KIND } from '../../../../model/enums';
import { AlkEvent } from '../../../../framework/events/alk.event';
import { GridsterWidgetItem } from '../../../../vo/workingzone/gridster-widget-item';
import { FormFieldObj } from '../../../../manager/baselines/form-field.obj';
import { PivotBasePop } from '../../pivot/renderers/settings/pivot-base.pop';
import { PivotEditItemRenderer } from '../../pivot/renderers/settings/pivot-edit-item.renderer';
import { gridsterItemEvent } from '../../form/generic/form-widget.gridster.component';

@Component({
  // popUp d'édition des forms : gestion des champs affichés
  selector: 'calendar-extended-pop',
  templateUrl: './calendar-extended.pop.html',
})
export class CalendarExtendedPop extends PivotBasePop {

  
  public popUpMode: WIDGET_KIND = WIDGET_KIND.CALENDAR; // le mode de cette pop, pour alimenter les PKD
  public renderer: any = PivotEditItemRenderer;
  public widgets: GridsterWidgetItem[];

  /** mise en place des écouteurs */
  public addListeners(): void {
    super.addListeners();
  }

  /**
   * @override
   * sur séquence de démarrage, alimentation des listes avec leurs DS
   */
  public feedDatasources(): void {
    super.feedDatasources();


    this.widgets = this.context.ff?.map((wcio: WidgetConfigurationItemObj) => {
      const result: GridsterWidgetItem = new GridsterWidgetItem(wcio, new FormFieldObj(this.widget, this.fei, wcio));
      return result;
    }) || [];

  }

  /** icone de suppression globale */
  public onDeleteClick(): void {
    this.widgets = [];
  }

  onWidgetsChanged(event: gridsterItemEvent) {
    // console.log('onWidgetsChanged',event, this.widgets);
    switch(event.action) {
      case EM_ACTION.CREATE:
        this.widgets = [event.item, ...this.widgets];
        break;
      case EM_ACTION.UPDATE:
        // console.log('onWidgetsChanged rien a faire');
        event.item.updateCoords(); // mise à jour des coords
        break;
      case EM_ACTION.DELETE:
        this.widgets.splice(this.widgets.indexOf(event.item), 1);
        break;     
    }
  }

  public updateContext(): void {
    super.updateContext();

    this.context.ff = this.widgets.map(w => w.source);
  }

  /**
   * override pour passage du resize sur les champs posés en sublist
   * @param e alkEvent, data = [pivotField, wizBaseCollector]
   */
  //  protected showConfPop(e: AlkEvent): void {
  //   // neutralisation conf des fields
  // }

}
